import { createSlice } from '@reduxjs/toolkit'
import { TalkChannelFontColors } from '../../../Codes'

export const initialThumbnailRecommendState = {
  dominantColors: [],
  thumbnail: undefined,
  backgroundColor: undefined,
  proposalPhraseTop: '',
  proposalPhraseBottom: '',
  fontColor: TalkChannelFontColors.BLACK,
}
const thumbnailRecommendSlice = createSlice({
  name: 'thumbnailRecommend',
  initialState: initialThumbnailRecommendState,
  reducers: {
    reset: () => initialThumbnailRecommendState,
    setDominantColors: (state, { payload: dominantColors }) => {
      state.dominantColors = dominantColors
    },
    setThumbnail: (
      state,
      { payload: { id, url, name, size, width, height } }
    ) => {
      state.thumbnail = {
        id,
        url,
        name,
        size,
        width,
        height,
      }
    },
    setThumbnailRecommendId: (state, { payload: { dspImageDtos } }) => {
      const image = dspImageDtos.find(
        ({ url }) => state?.thumbnail?.url === url
      )
      if (image) {
        state.thumbnail.id = image.id
      }
    },
    clearThumbnail: state => {
      state.thumbnail = undefined
      state.dominantColors = []
      state.backgroundColor = undefined
      state.fontColor = TalkChannelFontColors.BLACK
    },
    setBackgroundColor: (state, { payload: backgroundColor }) => {
      state.backgroundColor = backgroundColor
    },
    setProposalPhraseTop: (state, { payload: proposalPhraseTop }) => {
      state.proposalPhraseTop = proposalPhraseTop
    },
    setProposalPhraseBottom: (state, { payload: proposalPhraseBottom }) => {
      state.proposalPhraseBottom = proposalPhraseBottom
    },
    setFontColor: (state, { payload: fontColor }) => {
      state.fontColor = fontColor
    },
    importThumbnailRecommend: (state, { payload: thumbnailRecommend }) =>
      thumbnailRecommend,
  },
})
export const {
  reset,
  setDominantColors,
  setThumbnail,
  setThumbnailRecommendId,
  clearThumbnail,
  setBackgroundColor,
  setProposalPhraseTop,
  setProposalPhraseBottom,
  setFontColor,
  importThumbnailRecommend,
} = thumbnailRecommendSlice.actions

export default thumbnailRecommendSlice.reducer

export const validateThumbnailRecommend = (
  isLegalNotice,
  licenseNumber,
  license,
  bothLegalNoticeChecked,
  { thumbnail, backgroundColor, proposalPhraseTop, proposalPhraseBottom }
) => ({
  thumbnail: thumbnail === undefined && '썸네일 이미지를 등록하세요.',
  backgroundColor: backgroundColor === undefined && '배경 색상을 선택하세요.',
  proposalPhraseTop: proposalPhraseTop === '' && '상단 홍보문구를 입력하세요.',
  proposalPhraseBottom:
    ((isLegalNotice &&
      !bothLegalNoticeChecked &&
      licenseNumber.trim() === '' &&
      proposalPhraseBottom.trim() === '') ||
      (isLegalNotice &&
        bothLegalNoticeChecked &&
        license.recommendLicenseNumber.trim() === '' &&
        proposalPhraseBottom.trim() === '') ||
      (!isLegalNotice && proposalPhraseBottom.trim() === '')) &&
    '하단 홍보문구를 입력하세요.',
})

export const getThumbnailRecommendAssetData = (
  state,
  licenseNumber,
  license,
  bothLegalNoticeChecked
) => {
  const assets = [
    {
      type: 'THUMBNAIL_RECOMMEND',
      data: {
        image: {
          id: state.thumbnail.id,
          url: state.thumbnail.url,
          w: state.thumbnail.width,
          h: state.thumbnail.height,
          name: state.thumbnail.name,
          size: state.thumbnail.size,
        },
      },
    },
    {
      type: 'BACKGROUND_COLOR',
      data: { color: state.backgroundColor },
    },
    {
      type: 'FONT_COLOR',
      data: { color: state.fontColor },
    },
    {
      type: 'PROPOSAL_PHRASE_TOP',
      data: { text: state.proposalPhraseTop },
    },
  ]
  if (
    (!bothLegalNoticeChecked && licenseNumber.trim() === '') ||
    (bothLegalNoticeChecked && license.recommendLicenseNumber.trim() === '')
  ) {
    assets.push({
      type: 'PROPOSAL_PHRASE_BOTTOM',
      data: { text: state.proposalPhraseBottom },
    })
  }
  return {
    type: 'THUMBNAIL_RECOMMEND',
    assets,
  }
}
